import { render, staticRenderFns } from "./PurchaseInvoices.vue?vue&type=template&id=d8144e6c&scoped=true"
import script from "./PurchaseInvoices.vue?vue&type=script&lang=js"
export * from "./PurchaseInvoices.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInvoices.vue?vue&type=style&index=0&id=d8144e6c&prod&lang=css"
import style1 from "./PurchaseInvoices.vue?vue&type=style&index=1&id=d8144e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8144e6c",
  null
  
)

export default component.exports